import { useQuery } from '@apollo/client'
import { gql } from '@apollo/client'
import moment from 'moment-timezone'
import { useMemo } from 'react'

import { useVariables } from '../../../variables'

interface IGetNormalizationStatus {
  getLatestNormalizedUpdatedTime: {
    nodes: {
      updatedAt: string
    }[]
  }
}

interface IGetNormalizationStatusVariables {
  iNormalizationTable: string
}

const query = gql`
  query GetNormalizationUpdatedTime($iNormalizationTable: String!) {
    getLatestNormalizedUpdatedTime(iNormalizationTable: $iNormalizationTable) {
      nodes {
        updatedAt
      }
    }
  }
`

const useNormalizationUpdatedAt = () => {
  const { variables } = useVariables()

  const iNormalizationTable = variables.farwestNormalizeStatus || ''

  const { data, loading } = useQuery<
    IGetNormalizationStatus,
    IGetNormalizationStatusVariables
  >(query, {
    variables: {
      iNormalizationTable,
    },
    skip: !iNormalizationTable,
  })

  return {
    data: useMemo((): string[] | null => {
      const updatedAt =
        data?.getLatestNormalizedUpdatedTime.nodes?.[0]?.updatedAt
      if (!updatedAt) return null

      return updatedAt
        ? [
            `Last updated at: ${moment
              .utc(updatedAt)
              .tz('America/Los_Angeles')
              .format('MM/DD/YY HH:mm:ss')} PT`,
          ]
        : null
    }, [data]),
    loading,
  }
}

export default useNormalizationUpdatedAt
